//直播公开课
const index = () => import('@/pages/trainEntrance/index.vue');
const questionnaire = () => import('@/pages/trainEntrance/questionnaire.vue');
const questionnList = () => import('@/pages/trainEntrance/questionnList.vue');

export default [
  {
    path: '/trainEntrance',
    component: index,
    meta: {
    },
  },
  {
    path: '/questionnaire',
    component: questionnaire,
    meta: {
    },
  },
  {
    path: '/questionnList',
    component: questionnList,
    meta: {
    },
  },
];
